var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reaction",on:{"click":function($event){return _vm.$emit('react')}}},[_c('span',[_vm._v(_vm._s(_vm.reaction.name))]),_vm._v(" "),_c('i',{class:((_vm.reaction.class) + " fa-fw")})])}
var staticRenderFns = []

export { render, staticRenderFns }